import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Icon({ framed, className, children, ...rest }) {
    return (_jsx("span", { className: cn("fwfa-icon", framed && "fwfa-icon--framed", className), ...rest, children: children }));
}
//# sourceMappingURL=Icon.js.map